import { ComponentStoreV2Factory } from '../../../modules/shared/store/common/component-store-v2.factory';
import { computed, Injectable } from '@angular/core';
import { featureOn } from '../../../feature-flag';

@Injectable()
export class SocialServiceIndividualPlanWidgetStore extends ComponentStoreV2Factory {

    public readonly revisions = computed(() => {
        const now = new Date();
        now.setHours(23, 59, 59, 999);

        const revisions = featureOn.SOCIAL_SERVICE_DASHBOARD
            ? this.data.getIndividualPlanDashboardRevisions()
            : this.data.getIndividualPlanRevisions();

        return (revisions || []).map((it) => ({
            ...it,
            lastDay: new Date(it.deadlineDate || new Date()) < now,
        }));
    });

}
